import { styled } from 'stitches.config'

export const FeedingGuidelinesRoot = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '$4',
  position: 'relative',
  paddingTop: '$7',
  paddingBottom: '$10',
  backgroundColor: '$accent-white',

  '@bp2': {
    padding: '$6',
    paddingTop: '$12',
    paddingBottom: '$10',
  },
})

export const GuidelineList = styled('ul', {
  listStyle: 'none',
  padding: 0,
  margin: 0,
  width: '100%',
  maxWidth: '1200px',
  marginTop: '$4',

  '&.desktop': {
    display: 'none',
  },
  '&.mobile': {
    display: 'block',
  },
  '@bp2': {
    '&.desktop': {
      display: 'block',
    },
    '&.mobile': {
      display: 'none',
    },
  },
})

export const Guideline = styled('li', {
  color: '$accent-black',
  textAlign: 'center',
  fontFamily: '$primary',
  fontSize: '$body',
  fontWeight: '$regular',
  lineHeight: '1.2',
  marginBottom: '$3',

  '@bp2': {
    fontSize: '$bodyLarge',
    lineHeight: '40px',
    marginBottom: '$1'
  },
})

export const DogImagesWrapper = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-end',
    width: '100%',
    marginTop: '-$9',
  },
})

export const DogImage = styled('div', {
  marginRight: '-20px',

  '&:last-child': {
    marginRight: 0,
  },

  variants: {
    dog: {
      smallDog: {},
      mediumDog: {},
      largeDog: {
        marginRight: '-60px',
      },
      xlargeDog: {
        marginRight: '-60px',
      },
      xxlargeDog: {},
    },
  },
})

export const WeightRangeIndicator = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
    // width: '1600px',
    width: '100%',
    height: '5px',
    background: '$primary-500',
    marginTop: '0',
  },
})

export const WeightWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',
  maxWidth: '1860px',
  marginTop: '-32px',
})

export const WeightText = styled('span', {
  display: 'none',

  '@bp2': {
    display: 'block',
    position: 'relative',
    bottom: '-30px',
    color: '$accent-black',
    fontFamily: '$primary',
    fontSize: '$h5',
    fontWeight: '$medium',
    textAlign: 'center',
  },
})

export const Span = styled('span', {
  fontWeight: '$medium',
})

export const RedArrow = styled('div', {
  display: 'none',
  flexDirection: 'row',
  gap: 0,
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '1840px',
  paddingLeft: '64px',
  paddingRight: '64px',
  '@bp3': { display: 'flex' },
})
